import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexModule } from "@vp/shared/directives/flex";
import { NgxPermissionsModule } from "ngx-permissions";
import { BottomNavCopyrightComponent } from "./bottom-nav-copyright.component";

@NgModule({
  imports: [CommonModule, NgxPermissionsModule.forChild(), FlexModule],
  declarations: [BottomNavCopyrightComponent],
  exports: [BottomNavCopyrightComponent]
})
export class BottomNavCopyrightModule {}
